import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'

import styles from './HeaderLoading.module.css'

export const HeaderLoading = () => {
  return (
    <>
      <div className={styles.titleLoadingSkeleton}>
        <IssuesLoadingSkeleton height="xl" width="400px" />
      </div>
      <div className={styles.metadataLoadingSkeleton}>
        <IssuesLoadingSkeleton borderRadius="pill" height="xl" width="80px" />
        <IssuesLoadingSkeleton height="lg" width="200px" />
      </div>
    </>
  )
}
